<template>
  <v-menu
    v-model="showPicker"
    :close-on-content-click="false"
    max-width="50%"
    transition="scale-transition"
    offset-y
  >
    <template v-slot:activator="{ on }">
      <ValidationProvider :name="$t(dateName)" :rules="{ required: true }" v-slot="{ errors }">
        <v-text-field
          v-model="pickerDate"
          readonly
          v-on="on"
          :disabled="isAllTextFieldDisabled"
          :error-messages="errors[0]"
          @keyup.enter="keyupEnter"
        >
          <template v-slot:label>
            <span class="red--text">
              <strong>* </strong>
            </span>
            {{ $t(dateName) }}
          </template>
        </v-text-field>
      </ValidationProvider>
    </template>
    <v-date-picker
      v-model="pickerDate"
      :locale="getLocale"
      @input="showPicker = false"
    ></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: 'DatePickerExpDate',
  props: {
    dateName: {
      type: String
    },
    isAllTextFieldDisabled: {
      type: Boolean,
      default: false
    },
    createTime: {
      type: Number,
      default: 0
    },
    expDate: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      showPicker: false,
      pickerDate: ''
    }
  },
  mounted () {
    this.setTime()
  },
  computed: {
    getLocale () {
      return this.$i18n.locale
    }
  },
  methods: {
    keyupEnter (event) {
      this.showPicker = false
      this.$emit('keyupEnter', event)
    },
    convertToDateTimeFormat (timestamp) {
      if (timestamp === 0) {
        return ''
      } else {
        return this.$moment(new Date(timestamp)).format('YYYY-MM-DD')
      }
    },
    setTime () {
      if (!this.expDate) {
        let tempDate = new Date(this.createTime)
        this.pickerDate = new Date(tempDate.setMonth(tempDate.getMonth() + 1))
          .toISOString()
          .slice(0, 10)
        this.toTimestamp(this.pickerDate)
      } else {
        this.pickerDate = this.convertToDateTimeFormat(this.expDate)
      }
    },
    toTimestamp (val) {
      let timestamp = Date.parse(val + ' 23:59:59:999')
      this.$emit('setDate', timestamp)
    }
  },
  components: {},
  watch: {
    pickerDate (newVal) {
      this.toTimestamp(newVal)
    },
    createTime () {
      this.setTime()
    }
  }
}
</script>

<style></style>
